<template>
  <div class="service-page">
    <section class="masthead hero-text-img-section">
      <div class="container-fluid px-0">
        <div class="row justify-content-center mt-10 border-20">
          <div class="col-lg-8 z-100 text-center">
            <h1 class="secondary-color">STUDY ABROAD CONSULTING</h1>
            <h2 class="page-intro-line">
              <!-- A one-stop solution to all your education needs -->
              Chart Your Way to Global Success through our Study Abroad
              Consulting
            </h2>
            <p class="main-content-1 mt-2">
              <!-- We pave a way for you to excel in your abroad education plans by shouldering all the 
              responsibilities of admission to accommodation, without making any exceptions. What’s more, 
              all this services are offered to give you value and we do not charge a penny for it.  -->
              From Consulting for Global Placement, Embark on a Journey of
              Success
            </p>
          </div>
          <div class="col-lg-12 text-center abroad-hero-img">
            <img
              src="@/assets/imgs/study-abroad-hero-img.png"
              alt="Study Abroad Agency"
              data-aos="fade-up"
              data-aos-duration="500"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="hero-text-img-section mt-xl-n5">
      <div class="container-fluid px-0">
        <div class="row justify-content-center border-20">
          <div class="col-lg-6 text-center">
            <blockquote>
              <!-- Your dream of studying abroad is actually the reality you will be
              living and breathing in a few days. There is no stop to that
              dream, as we help you realize it and achieve it without any
              interruptions. -->
              "Education is the most powerful weapon which you can use to change
              the world."
            </blockquote>
            <p>- Nelson Mandela</p>
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-7">
            <h2 class="main-heading-1">
              1. Admissions
            </h2>
            <p class="main-content-2">
              <!-- We have put forward a dedicated 3C’s model allows us to mentor and
              guide you to identify the right Course, Country &amp; College.
              Each college has its own application requirement like online or
              offline documents, attestation / transcripts, recommendation
              letters, student portfolio, statement of purpose / motivational
              letters / essay, parent’s declaration, test or interview etc. So,
              we at Aliff is proud of our dedicated admission team who have the
              checklist handy for you. This team of experts help you with your
              documents and make the process feel like an easy task. Why?
              Because, our team is regularly trained by foreign universities.
              This gives us an edge over the others and when consulting we are
              always counting in the practical insights. This makes your
              admission process to a foreign university as easy as it sounds! -->
            </p>

            <ul>
              <li>
                Our 3C's model guides students in finding the perfect Course,
                Country, and College for their educational journey.
              </li>
              <li>
                Our admission team is well-prepared with the necessary
                checklists to make your application process smooth, considering
                the unique requirements of each college.
              </li>
              <li>
                Our experts receive regular training from foreign universities,
                giving you practical insights and a competitive advantage.
              </li>
              <li>
                We assist you with organizing your documents, ensuring a
                stress-free experience throughout the admission process.
              </li>
              <li>
                Our services come at no cost to you. We are committed to helping
                you succeed without any financial burden.
              </li>
            </ul>

            <div class="pt-3 pt-lg-5 row jc-space-between">
              <div class="admission-img">
                <img
                  src="@/assets/imgs/admission-1.png"
                  class="img-fluid border-all mr-2"
                />
              </div>
              <!-- <div class="benefits-box mr-2">
                <h2 class="main-heading-1">Benefits</h2>
                <ul class="benefit-list p-inline-start-30">
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
          <div class="col-md-12 col-lg-5">
            <!-- <img src="@/assets/imgs/mentor.png" class="img-fluid border-all" /> -->

            <section class="roadmap">
              <div class="roadmap-block">
                <div class="roadmap-dot">1</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-mortarboard"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Student Profiling</h1>
                    <p class="main-contant">
                      3C Model <br />
                      Right Cource, College & Country
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Documentation</h3>
                  <p>
                    No long lists, just the right concise list sans confusion
                  </p> -->
                </div>
              </div>

              <div class="roadmap-block">
                <div class="roadmap-dot roadmap-dot-1">2</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-pencil"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Application</h1>
                    <p class="main-contant">
                      Documentation, University <br />
                      application & Interview prep
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Application</h3>
                  <p>
                   We take care of the process, you relax
                  </p> -->
                </div>
              </div>

              <div class="roadmap-block">
                <div class="roadmap-dot">3</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-journal-bookmark"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Essay / SOP</h1>
                    <p class="main-contant">
                      Assistance through formal<br />
                      Structure and Review
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Follow-up</h3>
                  <p>
                    We are on it. You can concentrate on packing instead
                  </p> -->
                </div>
              </div>

              <!-- <div class="roadmap-block">
                <div class="roadmap-dot"></div>
                <div class=" roadmap-content">
                  <h3 class="roadmap-title">
                    Admission Letter
                  </h3>
                  <p>
                    Delivered to your mailbox
                  </p>
                </div>
              </div> -->
            </section>
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-7">
            <h2 class="main-heading-1">
              2. Visa
            </h2>
            <!-- <p class="main-content-2">
              Visa and its technicalities is likely to be a long drawn,
              complicated process. From furnishing a list of documents that
              prove your financial standing, to medical examination papers,
              income tax returns, police clearance certificate, health insurance
              and much more, you will also have to think and plan the document
              sets based on the country or the university you apply to. It is as
              complicated as it sounds. But, you have help at hand with Aliff.
              Our team of experts makes this complex visa process seem like a
              child’s play and all you need to do is go and attend your visa
              interview. What’s more, we tackle the process not only in advance
              but help you prepare for your interview at least nine months in
              advance from the date the college session is about to start. This
              gives you a safety cushion and at all times you know, we have your
              back!
            </p> -->
            <ul>
              <li>
                Obtaining a study visa can be overwhelming due to the complex
                and varying requirements set by different countries and
                universities.
              </li>
              <li>
                Aliff's expert team simplifies the visa process, ensuring a
                stress-free experience for students.
              </li>
              <li>
                We guide you through each step, from gathering financial
                documents to medical exams and police clearance certificates.
              </li>
              <li>
                Our team stays ahead of deadlines, starting the interview
                preparation at least nine months before your college session
                begins.
              </li>
              <li>
                With Aliff by your side, you can have peace of mind, knowing
                that we are committed to your success and will support you
                throughout the visa application journey.
              </li>
            </ul>

            <div class="pt-3 pt-lg-5 row jc-space-between">
              <div class="admission-img">
                <img
                  src="@/assets/imgs/visa.png"
                  class="img-fluid border-all mr-2"
                />
              </div>
              <!-- <div class="benefits-box mr-2">
                <h2 class="main-heading-1">Benefits</h2>
                <ul class="benefit-list p-inline-start-30">
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
          <div class="col-md-12 col-lg-5">
            <!-- <img src="@/assets/imgs/mentor.png" class="img-fluid border-all" /> -->

            <section class="roadmap">
              <div class="roadmap-block">
                <div class="roadmap-dot">4</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-currency-dollar"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Educational Loan</h1>
                    <p class="main-contant">
                      Bank refrences, doc checklist & better rate of interest
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Documentation</h3>
                  <p>
                    No confusion, only solution
                  </p> -->
                </div>
              </div>

              <div class="roadmap-block">
                <div class="roadmap-dot roadmap-dot-1">5</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-globe2"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Visa</h1>
                    <p class="main-contant">
                      Documentation, application & prepration
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Application</h3>
                  <p>
                    We take care of it, you just wait for the call
                  </p> -->
                </div>
              </div>

              <div class="roadmap-block">
                <div class="roadmap-dot">6</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-currency-exchange"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Fee & Currency</h1>
                    <p class="main-contant">
                      Fee transfer foreign exchange at best rate possible
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Follow-up</h3>
                  <p>
                    We get it done in time. You can get ready with what you want to wear on the interview days
                  </p> -->
                </div>
              </div>

              <!-- <div class="roadmap-block">
                <div class="roadmap-dot"></div>
                <div class=" roadmap-content">
                  <h3 class="roadmap-title">
                    Interview
                  </h3>
                  <p>
                     Done. Excelled. Plan your tickets.
                  </p>
                </div>
              </div> -->
            </section>
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-7">
            <h2 class="main-heading-1">
              3. Pre- departure
            </h2>
            <!-- <p class="main-content-2">
              Your bags are packed and now you are all set to travel safely to
              the foreign land of your choice. Your university and the land of
              opportunities is waiting for you. At this stage, given our decades
              of experience we help you sort out your transit in a little more
              planned way. How do we do that? Well, we belt out the itinerary
              from our real experiences, as our team members have travelled
              extensively abroad and hence, are in a better position to assist
              you to be fully prepared well in advance. What we do? We help you
              book your flight, arrange accommodation, buy an insurance, sort
              out your foreign exchange worries, help you stay connected with
              the right phone sim card, and support you with airport pickup on
              arrival too. With such organized approach to a new start, will you
              still wait to get in touch with us?
            </p> -->
            <ul>
              <li>
                Aliff offers personalized travel assistance for students
                preparing to study abroad.
              </li>
              <li>
                Our experienced team provides guidance for flight bookings,
                accommodation arrangements, insurance, and foreign exchange.
              </li>
              <li>
                We draw on real-life travel experiences to offer practical
                advice and support.
              </li>
              <li>
                Enjoy the convenience of a local phone sim card provided by
                Aliff.
              </li>
              <li>
                We ensure a smooth start to your journey with airport pickup
                upon arrival.
              </li>
              <li>
                Experience hassle-free travel planning with Aliff and focus on
                your new adventure abroad.
              </li>
            </ul>

            <div class="pt-3 pt-lg-5 row jc-space-between">
              <div class="admission-img">
                <img
                  src="@/assets/imgs/departure.png"
                  class="img-fluid border-all mr-2"
                />
              </div>
              <!-- <div class="benefits-box mr-2">
                <h2 class="main-heading-1">Benefits</h2>
                <ul class="benefit-list p-inline-start-30">
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                  <li class="benefit">
                    Application fee waiver
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
          <div class="col-md-12 col-lg-5">
            <!-- <img src="@/assets/imgs/mentor.png" class="img-fluid border-all" /> -->

            <section class="roadmap">
              <div class="roadmap-block">
                <div class="roadmap-dot">7</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-arrow-up-right-circle"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Air Ticket</h1>
                    <p class="main-contant">
                      Bank refrences, doc checklist & better rate of interest
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Documentation</h3>
                  <p>
                    We get it all in one place. You need not worry.
                  </p> -->
                </div>
              </div>

              <div class="roadmap-block">
                <div class="roadmap-dot roadmap-dot-1">8</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-briefcase"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Pre Departure</h1>
                    <p class="main-contant">
                      Checklist on things to carry & essential tips on living
                      abroad
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Planning</h3>
                  <p>
                     We take care of the process, you relax
                  </p> -->
                </div>
              </div>

              <div class="roadmap-block">
                <div class="roadmap-dot">9</div>
                <div class="roadmap-content">
                  <div class="roadmap-icon">
                    <i class="bi bi-house-door"></i>
                  </div>
                  <div class="roadmap-contant-1 text-center">
                    <div class="square"></div>
                    <h1 class="roadmap-title">Accommodation</h1>
                    <p class="main-contant">
                      On or off campus based on your prefrence & budget
                    </p>
                  </div>
                  <!-- <h3 class="roadmap-title">Bookings</h3>
                  <p>
                    We are on it. You can concentrate on packing instead
                  </p> -->
                </div>
              </div>

              <!-- <div class="roadmap-block">
                <div class="roadmap-dot"></div>
                <div class=" roadmap-content">
                  <h3 class="roadmap-title">
                     Ready to go!
                  </h3>
                  <p>
                    Done. Excelled. Plan your tickets.
                  </p>
                </div>
              </div> -->
            </section>
          </div>
        </div>
      </div>
    </section>
    <section class="student-section py-xl-5 my-5">
      <div class="container-fluid bg-row py-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <div class="main-heading-1">
              <!-- We make studying abroad a simple step for you! -->
              Your passport to affordable international education
            </div>
            <div class="main-content-1">
              <!-- Just climb higher without having to look at the cost. Our prices
              are customized to give you an edge without letting you feel any
              burden. -->
              Ascend to greater heights without worrying about the cost. Our
              tailored prices give you an advantage without weighing you down.
            </div>
          </div>
          <div class="col-lg-12 mt-5">
            <VideoTestimonialSlider
              :testimonialsData="
                testimonialData['study-abroad']['testimonial-2']
              "
            />
          </div>
          <div class="col-lg-12 mt-5 stu-card-section">
            <TextTestimonialSlider
              :testimonialsData="
                testimonialData['study-abroad']['testimonial-1']
              "
            />
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="banner-sm-section"> -->
    <!-- <b-modal
        id="book-counselling-modal-id"
        ref="book-counselling-modal-ref"
        centered
        title="Book Free Counselling"
        cancel-disabled
        ok-disabled
        :hide-footer="true"
      >
        <vue-calendly :height="600" url="https://calendly.com/info-aliff-39025">
        </vue-calendly>
      </b-modal> -->
    <!-- <div
        class="container-fluid bg-primary-gradient border-20 d-flex justify-content-center bg-primary-responsive"
      >
        <div class="col-lg-11">
          <div class="row align-items-center">
            <div class="col-xl-7 col-md-7 py-4 py-md-0">
              <div>
                <h1 class="text-center-responsive book-counselling pb-3">
                  Studying abroad is much easier with Aliff. Just one call away!
                </h1>
                <div
                  class="mt-4 d-flex align-items-center flex-wrap flex-fd-col"
                >
                  <button
                    v-b-modal.book-counselling-modal-id
                    class="btn btn-white-bg-no-border mr-md-3 mb-3 mb-lg-0 mr-2"
                  >
                    Book free expert counselling
                  </button> -->
    <!-- <button
                      @click="bookFreeCounselling"
                      class="btn btn-common-1 btn-secondary mr-md-3"
                    >
                      Book free expert counselling
                    </button> -->
    <!-- <a href="tel:+919987099890" class="anchor-text-white"
                    >Call us at +91 9987099890</a
                  >
                </div>
              </div>
            </div>
            <div
              class="
              col-md-6 col-xl-2
              offset-xl-3
              px-0
              d-flex
              justify-content-end
            "
            >
              <div class="d-flex justify-content-end">
                <img
                  src="@/assets/imgs/city-illustration-light.png"
                  class="d-none d-md-block pt-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- contactup page section -->
    <ContactusSection :source="22"/>

    <!-- <RecentPostSection :recentPostsData="recentPostData['abroad-page']['data-1']" /> -->

    <RecentPostSection
      :recentPostsData="recentPostData['abroad-page']['data-1']"
    />
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
import { DASHBOARD_REGISTER_URL } from "@/config";
import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
import RecentPostSection from "@/components/partials/RecentPostSection.vue";
import ContactusSection from "@/components/partials/ContactusSection.vue";
export default {
  metaInfo: {
    title:
      "Study Abroad Consultants - Study Abroad Agency - Aliff",
    htmlAttrs: {
      lang: "en-US"
    },
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Looking for Study Abroad Consultants? Aliff offers the best abroad consultants for your carrier. Pursue your Carries with our expert  advice. Consult now!"
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" }
    ]
  },
  components: {
    BookFreeCounselling,
    VideoTestimonialSlider,
    TextTestimonialSlider,
    RecentPostSection,
    ContactusSection
  },
  data() {
    return {
      service: [],
      showPlan: false,
      DASHBOARD_REGISTER_URL,
      videoSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 2.5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      pricingSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },

      postSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  methods: {
    bookFreeCounselling() {},
    clickShowPlan() {
      this.showPlan = !this.showPlan;
    },
    async getServicePlan() {
      try {
        const response = await homeServices.getServicesAndPlans({
          service_id: 3
        });
        if (response.data.status) {
          this.service = response.data.data[0];
        }
      } catch (err) {
        console.log("Error in getting getServicePlan ", err);
      }
    },
    addCommas(amt) {
      return amt.toLocaleString("en-IN");
    }
  },
  beforeMount() {
    this.getServicePlan();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/AbroadCounselling.vue